module.exports = __webpack_public_path__ + "img/mentor3.db83043.jpg";